<template>
  <div class="mobile-box">
    <van-nav-bar title="祺信信息" />
    <van-cell-group inset class="top">
      <van-cell>
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span style="float: left;" class="title">祺信编号</span>
          <span style="float: right;" class="title">{{ gldInfo.gldId }}</span>
        </template>
      </van-cell>
      <van-cell>
        <template #title>
          <span class="title">祺信金额：<span style="color:red;">{{ gldInfo.gldAmt | splitK }}</span> 元</span>
        </template>
        <template #label>
          <template v-if="type == 'voucher'">
            <div class="title-time">
              <span style="float: left;">开立日：{{ gldInfo.openTime }}</span>
              <span style="float: right;">到期日：{{ gldInfo.exDayStr }}</span>
            </div>
          </template>
          <template v-else>
            <div class="title-time">
              <span style="float: left;">支付日：{{ gldInfo.wanderAboutTime }}</span>
              <span style="float: right;">到期日：{{ gldInfo.exDayStr }}</span>
            </div>
          </template>
        </template>

      </van-cell>
    </van-cell-group>
    <div class="info">
      <template v-if="type == 'voucher'">
        <van-cell-group inset>
          <van-cell>
            <template #title>
              <p>开立方企业名称</p>
              <p>开立方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.estb && gldInfo.estb.customerName }}</p>
              <p>{{ gldInfo.estb && gldInfo.estb.orgCode }}</p>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <p>担保方企业名称</p>
              <p>担保方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.guar && gldInfo.guar.guarantorName || '-' }}</p>
              <p>{{ gldInfo.guar && gldInfo.guar.guarantorOrgCode || '-' }}</p>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <p>接收方企业名称</p>
              <p>接收方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.rcPty && gldInfo.rcPty.customerName }}</p>
              <p>{{ gldInfo.rcPty && gldInfo.rcPty.orgCode }}</p>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <van-cell title="交易资料" is-link :to="`/mobile/dataType/${this.gldId}?tenantIds=${this.tenantIds}`" />
        </van-cell-group>
        <van-cell-group inset>
          <van-cell title="是否可变更到期日">
            <template #default>
              {{ gldInfo.canBeModified | GbCbmTrans }}
            </template>
          </van-cell>
        </van-cell-group>
      </template>
      <template v-else>
        <van-cell-group inset>
          <van-cell>
            <template #title>
              <p>兑付方企业名称</p>
              <p>兑付方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.estb && gldInfo.estb.customerName }}</p>
              <p>{{ gldInfo.estb && gldInfo.estb.orgCode }}</p>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <p>流转方企业名称</p>
              <p>流转方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.pypt && gldInfo.pypt.customerName }}</p>
              <p>{{ gldInfo.pypt && gldInfo.pypt.orgCode }}</p>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <p>接收方企业名称</p>
              <p>接收方信用代码</p>
            </template>
            <template #default>
              <p>{{ gldInfo.rcPty && gldInfo.rcPty.customerName }}</p>
              <p>{{ gldInfo.rcPty && gldInfo.rcPty.orgCode }}</p>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <van-cell>
            <span style="float: left;" class="van-cell__title">母祺信编号</span>
            <span style="float: right;" class="van-cell__value">{{ gldInfo.originalId }}</span>
          </van-cell>
        </van-cell-group>
      </template>

    </div>
  </div>
</template>
<script>
import './mobile.less'
import { getVoucherDetail } from '@/api/mobile.js'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      gldInfo: {}
    }
  },
  created() {
    console.log(this.$route.params)
  },
  mounted() {
    getVoucherDetail({ gldId: this.gldId, tenantIds: this.tenantIds }).then(res => {
      console.log(res)
      this.gldInfo = res.data
    })
  },
  computed: {
    gldId() {
      return this.$route.params.gldId
    },
    type() {
      return this.$route.params.type
    },
    tenantIds() {
      return this.$route.params.tenantIds
    }
  },
  methods: {},
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/mobile/QXDetails.vue